import * as React from 'react';
import { useSelector } from 'react-redux';

import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { AuthorAside, IAuthorAsideProps } from '../../components/author_aside';
import { selectAgentLevelInfo } from '../../selectors';
import { IState } from '../../store';
import { isPro, isHonest } from '../../utils/agent';
import { showCountrysideBuilderBadge } from '../../utils/suburban';

export const AuthorAsideContainer = () => {
  const agent = useSelector((state: IState) => state.offerData.agent);

  const props: IAuthorAsideProps = {
    agent: agent as IAgentSchema,
    agentReviews: useSelector((state: IState) => state.offerData.agentReviews),
    developer: useSelector((state: IState) => state.offerData.newObject && state.offerData.newObject.developer),
    offer: useSelector((state: IState) => state.offerData.offer),
    showCountrysideBuilderBadge: useSelector((state: IState) => showCountrysideBuilderBadge(state)),
    isProAgent: isPro(agent || ({} as IAgentSchema)),
    isHonestAgent: isHonest(agent || ({} as IAgentSchema)),
    agentLevelInfo: useSelector(selectAgentLevelInfo),
  };

  if (!agent) {
    return null;
  }

  return <AuthorAside {...props} />;
};
